import React, { useContext } from 'react';
import Head from '../Head';
import { getGlobalClassnamesForContext } from '@wix/da-react-context/pkg/helpers';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { FlagContext } from '@wix/da-react-context/pkg/flags/FlagContext';
import Flag from '@wix/da-react-context/pkg/flags/Flag/Flag';
import { useSelector } from 'react-redux';
import { getEnv } from '../Environment/redux/selectors';
import noop from 'lodash/noop';
import { ThemeOptions, ThemeSkin } from '@wix/da-react-context/pkg/constants';
import { getLang } from '../Head/redux/selectors';

export interface Props {
  themeSelector?: any;
  themeSkinSelector?: any;
  children?: React.ReactNode;
}

const Document: React.FC<Props> = ({ children, themeSelector, themeSkinSelector }) => {
  const session = useContext(SessionContext);
  const flags = useContext(FlagContext);
  const env = useSelector(getEnv);
  const theme: ThemeOptions = useSelector(themeSelector ?? noop);
  const themeSkin: ThemeSkin = useSelector(themeSkinSelector ?? noop);
  const lang: string = useSelector(getLang);
  return (
    <html lang={lang} data-appinfo={env.appInfo}>
      <Head />
      <body
        className={getGlobalClassnamesForContext({
          flags,
          isLoggedIn: session.isLoggedIn,
          isMobile: session.device?.isMobile,
          theme: theme ?? session.theme,
          themeSkin: themeSkin ?? session.themeSkin,
          isSisu: env.isSisu ?? false,
        })}
      >
        <Flag
          condition="strictmode"
          render={() => <React.StrictMode>{children}</React.StrictMode>}
          fallbackRender={() => <>{children}</>}
        />
      </body>
    </html>
  );
};
Document.displayName = 'Document';

export default Document;
